module.exports = __webpack_public_path__ + "static/thinking-fast-and-slow-0d0dedb011308ffa626c8b392c87b3d7.jpg";